var iconTypes = {
    active: 'active',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    incomplete: 'incomplete',
    optional: 'optional',
    partial: 'partial',
    processing: 'processing'
};
export default iconTypes;
